import produce from 'immer';
import * as ddActions from '../actions/dataDictionary';


const initialState = {
  ddCatalogProducts: [],
  ddCatalogProductsTotal: 0,
  ddCatalogProductsLoading: false
};

const formReducer = produce((state: IDataDictionaryState = initialState, action) => {
  switch (action.type) {
    case ddActions.GET_DD_PRODUCTS_TO_MAP_START: {
      state.ddCatalogProductsLoading = true;
      break;
    }

    case ddActions.GET_DD_PRODUCTS_TO_MAP_SUCCESS: {
      const { response } = action.data;

      state.ddCatalogProducts = response['hydra:member'];
      state.ddCatalogProductsTotal = response['hydra:totalItems'];
      state.ddCatalogProductsLoading = false;
      break;
    }

    case ddActions.GET_DD_PRODUCTS_TO_MAP_FAILED: {
      state.ddCatalogProductsLoading = false;
      break;
    }
  }
}, initialState);

export default formReducer;
